<!-- Session Expired Notification -->
<div *ngIf="notification" [ngClass]="notification.type === 'success' ? 'success-notification' : 'error-notification'">
  <svg *ngIf="notification.type === 'success'" class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#10b981"/>
    <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <svg *ngIf="notification.type === 'error'" class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#dc2626"/>
    <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <span [ngClass]="notification.type === 'success' ? 'success-notification-message' : 'error-notification-message'">{{ notification.message }}</span>
</div>

<!-- JWT Expiration Warning Alert -->
<div *ngIf="showWarning && timeRemaining !== null" class="jwt-expiration-alert">
  <div class="alert-content">
    <div class="alert-icon">⚠️</div>
    <div class="alert-message">
      <strong>Session Expiring Soon!</strong>
      <p>Your session will expire in <span class="timer">{{ formattedTime }}</span></p>
    </div>
    <div class="alert-actions">
      <button class="btn-refresh" (click)="onRefresh()">Stay Logged In</button>
      <!-- <button class="btn-logout" (click)="onLogout()">Logout</button> -->
    </div>
  </div>
</div>

<router-outlet></router-outlet>

